//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from "vuex";
export default {
  name: "InslerCervicalEstrogenLevelScoringMethod",
  data() {
    return {
      form: {
        value1: "",
        value2: "",
        value3: "",
        value4: "",
       
      },
      hasScore: false,
      disabled: false,
      dataList: [
        { value: "0", name: "无" },
        { value: "1", name: "颈管内" },
        { value: "2", name: "颈管口见黏液" },
        { value: "3", name: "溢出宫颈口" },
      ],
      dataList1: [
        { value: "0", name: "无" },
        { value: "1", name: "达阴道1/4" },
        { value: "2", name: "达阴道1/2" },
        { value: "3", name: "达阴道口" },
      ],
      dataList2: [
        { value: "0", name: "无" },
        { value: "1", name: "少许细条结晶" },
        { value: "2", name: "羊齿结晶" },
        { value: "3", name: "典型结晶" },
      ],
      dataList3: [
        { value: "0", name: "无" },
        { value: "1", name: "裂隙" },
        { value: "2", name: "部分开张" },
        { value: "3", name: "开张（瞳孔样）" },
      ],
    };
  },
  created() {
    this.hideLoad();
  },
  methods: {
    ...mapMutations(["hideLoad"]),
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this;
      let form = JSON.parse(JSON.stringify(self.form));
      let flag = true;
      let result = 0;
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false;
          } else {
            form[key] = Number(form[key]);
          }
        }
        result += Number(form[key]);
      }
      if (!flag) {
        self.hasScore = false;
        return "";
      } else {
        self.hasScore = true;
        return String(result);
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/InslerCervicalEstrogenLevelScoringMethod.vue